import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

export function getOptimizedImageUrl(url, width = 1200, quality = 85) {
  if (!url) return '';
  const rawUrl = Array.isArray(url) ? url[0] : url;
  if (!rawUrl || typeof rawUrl !== 'string') return '';
  
  if (rawUrl.includes('assets.auxodev.dk') && !rawUrl.includes('/cdn-cgi/image/')) {
    return rawUrl.replace('assets.auxodev.dk/', `assets.auxodev.dk/cdn-cgi/image/width=${width},quality=${quality},format=auto/`);
  }
  
  return rawUrl;
}
